import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import PeriodicReportFileCard from "../Card/PeriodicReportFileCard";
import { useSelector } from "react-redux";

function PeriodicReportDialog({
    onClose,
    open,
    fileList,
    setFileList,
    selectedUnit,
    existingReports,
    addAfterTable,
    updateAfterTable
}) {
    const fontSettings = useSelector(state => state.meeting.fontSettings);
    const { baseFontSize, titleFontSize } = fontSettings;

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="xl">
            <DialogTitle sx={{ fontSize: titleFontSize }}>
                {`Dosya İşlemleri (${fileList ? fileList.length : 0} Dosya)`}
            </DialogTitle>
            <DialogContent dividers sx={{ fontSize: titleFontSize }}>
                <PeriodicReportFileCard
                    fileList={fileList}
                    setFileList={setFileList}
                    selectedUnit={selectedUnit}
                    addAfterTable={addAfterTable}
                    updateAfterTable={updateAfterTable}
                    existingReports={existingReports}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" size="small" color="error" onClick={onClose} sx={{ fontSize: baseFontSize }}>
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PeriodicReportDialog;
